import { SectionSubject } from './components/subject-section';
import { DonorSection } from './components/donor-section';
import { OrganizationSection } from './components/organization-section';
import { PastConversationsSection } from './components/past-conversations-section';
import { AiEmailAssistantForm } from '@/schemas/ai-email-assistant';

type StepFields = keyof AiEmailAssistantForm;

export interface StepType {
  label: string;
  content: React.ComponentType;
  fields: StepFields[];
}

export const steps: StepType[] = [
  {
    label: 'Goal',
    content: SectionSubject,
    fields: ['messageType']
  },
  {
    label: 'Donor',
    content: DonorSection,
    fields: ['donorContext']
  },
  {
    label: 'Organization',
    content: OrganizationSection,
    fields: ['organizationContext']
  },
  {
    label: 'Past conversations',
    content: PastConversationsSection,
    fields: ['pastConversations']
  }
];

export const goals = [
  'Secure a meeting',
  'Start a conversation',
  'Make the ask',
  'Build the relationship',
  'Boost engagement',
  'Follow up & follow through',
  'Share something valuable',
  'Get a response',
  'Confirm a meeting',
  'Prompt a reply',
  'Reignite the conversation',
  'Move things forward',
  'Check in with purpose',
  'Spark new interest',
  'Nudge a decision',
  'Reconnect & respond',
  'Celebrate a milestone',
  'Clarify next steps',
  'Close the loop'
];
